import Vue from 'vue'
import router from './router'
import Storage from './storage'

var vue = new Vue({ router })
export const getQueryString =
    function(name, url = null) {
        if (url == null) {
            url = window.location.hash
        }
        url = decodeURIComponent(url)
        if (url.indexOf('?') == -1) {
            return null
        }
        const keyValueArr = url.split('?')[1].split('&')
        let paramObj = {}
        keyValueArr.forEach(item => {
            const keyValue = item.split('=')
            paramObj[keyValue[0]] = keyValue[1]
        })
        if (paramObj[name] != undefined) {
            return paramObj[name]
        }
        return null
    }
export const setStorage =
    function(key, val, ms = 0) {
        var obj = { name: key, value: val }
        if (ms == 0) {
            Storage.setItem(obj)
            return true
        }
        obj.expires = ms
        Storage.setItem(obj)
        return true
    }
export const getStorage =
    function(key) {
        return Storage.getItem(key)
    }
export const removeStorage =
    function(key) {
        return Storage.removeItem(key)
    }
export const clearStorage =
    function() {
        return Storage.clear()
    }
// 唤醒APP
export const invokeApp =
    function(method, args, fn, errorFn) {
        if (typeof args === 'function') {
            errorFn = fn;
            fn = args;
            args = undefined;
        }
        if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.jsToApp) {
            args = args || {};
            if (typeof fn === 'function') {
                var appToJs = 'appToJs' + method + (new Date()).getTime();
                window[appToJs] = function() {
                    fn.apply(window, Array.prototype.slice.call(arguments));
                    delete window[appToJs];
                };
                args.callback = appToJs;
            }
            args.method = method;
            window.webkit.messageHandlers.jsToApp.postMessage(args);
        } else if (window.jsToApp && window.jsToApp[method]) {
            var res = window.jsToApp[method](args ? JSON.stringify(args) : '');
            typeof fn === 'function' && fn(res);
        } else if (typeof errorFn === 'function') {
            errorFn(method);
        } else {
            throw new Error('未找到方法:' + method);
        }
    }
// 支付回调
export const payBack =
    function(data, product) {
        if (typeof data == 'string') {
            data = JSON.parse(data)
        }
        if (typeof product == 'string') {
            product = JSON.parse(product)
        }
        vue.$router.push({ path: 'result', query: { from: product.from } })
    }
// 事件触发
export const firebaseEvent = function(logEventWithName) {
    console.log('firebaseEvent: ' + logEventWithName)
    try {
        invokeApp('setAnalyticsLogEvent', {
            'name': logEventWithName,
        })
    } catch (err) {
        if (process.env.NODE_ENV === 'production') {
            console.log(err)
        }
    }
}